import { useIntl } from 'react-intl';

import { ContributionKind } from '../../../../Utils/Types/Posts';

interface ContributionLabelProps {
  contributionKindLabel: string | null | undefined;
  contributionKind: ContributionKind | null | undefined;
}

export default function ContributionLabel({
  contributionKind,
  contributionKindLabel,
}: ContributionLabelProps) {
  const intl = useIntl();

  const DEFAULT_CONTRIB_TYPE = `POST_FORM.CONTRIBUTION_KIND.OPTIONS.${contributionKind?.toUpperCase() || 'OTHER'}`;

  return contributionKind === 'other'
    ? contributionKindLabel
    : intl.formatMessage({ id: DEFAULT_CONTRIB_TYPE });
}
